export function registerDeviceToStream(userId: string, apiKey: any, token: string) {
  if (window.registerDeviceToStream || window.flutter_inappwebview) {
    const messageToFlutter = {
      streamUser: userId,
      streamKey: apiKey,
      streamToken: token,
    };
    const streamMessage = JSON.stringify(messageToFlutter);
    if (window.registerDeviceToStream) {
      window.registerDeviceToStream.postMessage(streamMessage);
    }
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('registerDeviceToStream', streamMessage);
    }
  }
}

export function clearNotifications() {
  if (window.clearAllNotifications) {
    window.clearAllNotifications.postMessage('');
  }
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('clearAllNotifications', '');
  }
}
